import ArrowRightIcon from "@sprout/icons/arrow_right";
import "./profile_card.scss";
import { Body, SectionTitle } from "@/sprout/typography";
import { Link as InertiaLink } from "@inertiajs/react";
import useTranslation from "@hooks/use_translation";
import useProfile from "@/queries/use_profile";
import IdentityVerificationBadge from "@/components/ui/identity_verification_badge";
import LoadingSpinner from "@/sprout/loading_spinner";
import ResumeUploadBox from "@components/dashboard/resume_upload_box";
import ProfileChecklist from "@components/dashboard/profile/profile_checklist.tsx";

const ProfileCardHeader = () => {
  const { t } = useTranslation("user");
  return (
    <InertiaLink href="/account" className="profile_card__header">
      <div className="profile_card__header__title">
        <SectionTitle>{t("profile_card_title")}</SectionTitle>
        <div className="profile_card__header__icon">
          <ArrowRightIcon />
        </div>
      </div>
      <Body className="section-subtitle">{t("profile_card_subtitle")}</Body>
    </InertiaLink>
  );
};

const ProfileCard = () => {
  const { t } = useTranslation("user");
  const { data, isLoading, error } = useProfile();

  if (isLoading) {
    return (
      <div className="profile_card">
        <ProfileCardHeader />
        <div className="profile_card__content">
          <div className="flex justify-center items-center h-32">
            <LoadingSpinner size="medium" />
          </div>
        </div>
      </div>
    );
  }

  if (error || !data) {
    return (
      <div className="profile_card">
        <ProfileCardHeader />
        <div className="profile_card__content">
          <Body>{t("defaultError")}</Body>
        </div>
      </div>
    );
  }

  const { firstName, lastName, isIdentityVerified, identityVerificationPartner } = data;

  const hasAnyName = Boolean(firstName || lastName);
  const hasResume = Boolean(data.resume);

  let profileContent = null;

  if (hasResume && hasAnyName) {
    const initials = [firstName, lastName]
      .filter(Boolean)
      .map((n) => n![0].toUpperCase())
      .join("");
    profileContent = (
      <>
        <div className="flex items-center gap-3">
          <div className="profile_card__avatar">{initials}</div>
          <div>
            <div className="flex items-center gap-2">
              <Body className="name">
                {firstName} {lastName}
              </Body>
              {isIdentityVerified && (
                <IdentityVerificationBadge partner={identityVerificationPartner} />
              )}
            </div>
            {data.location && <Body className="location">{data.location.display_name}</Body>}
          </div>
        </div>
        <hr />
      </>
    );
  } else if (!hasResume) {
    profileContent = (
      <div className="flex flex-col gap-2">
        <ResumeUploadBox source="dashboard_profile_card" />
      </div>
    );
  }

  return (
    <div className="profile_card">
      <ProfileCardHeader />
      <div className="profile_card__content">
        {profileContent}
        <ProfileChecklist />
      </div>
    </div>
  );
};

export default ProfileCard;
